import styled from "styled-components";
import {
  getBackgroundColor,
  getColor,
  getDisabledColor
} from "../../../ui/_themes/helpers";
import { mobile } from "../../_themes/constants/";
import { StartButton } from "../../StartButton";

export const AutoplayStartButton: any = styled(StartButton)`
  display: inherit;
  flex: 1;
  justify-content: center;
  align-items: center;

  svg {
    border-radius: 50%;
    background: ${({ disabled }: any) =>
      disabled
        ? getDisabledColor(
            "settingsWindowAutoplayStartButton",
            "settingsWindow.autoplayStartButton"
          )
        : getColor(
            "settingsWindowAutoplayStartButton",
            "settingsWindow.autoplayStartButton"
          )};
    color: ${() =>
      getBackgroundColor(
        "settingsWindowAutoplayStartButton",
        "settingsWindow.autoplayStartButton"
      )};

    @media (orientation: landscape) {
      width: 1.1em;
      height: 1.1em;
    }

    @media (orientation: portrait) {
      width: ${mobile.portrait.middlePanel.footer.icon.width};
      height: ${mobile.portrait.middlePanel.footer.icon.height};
    }
  }
`;
